<div class="alert alert-dismissible alert-{{getClass()}}">
  <button type="button" class="close" (click)="close()" tabindex="-1" data-dismiss="modal" aria-hidden="true">&times;</button>
  {{message}}
</div>
